var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 0.333344C6.15306 0.333344 0.333344 6.15306 0.333344 13.3333V14.3333H14.3333V0.333344H13.3333ZM12.3333 12.3333H2.37817C2.85363 7.05573 7.05573 2.85363 12.3333 2.37817V12.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 5.66669H17.6667V7.66669H18.6667C24.7424 7.66669 29.6667 12.591 29.6667 18.6667C29.6667 24.7424 24.7424 29.6667 18.6667 29.6667C12.591 29.6667 7.66668 24.7424 7.66668 18.6667V17.6667H5.66668V18.6667C5.66668 25.847 11.4864 31.6667 18.6667 31.6667C25.847 31.6667 31.6667 25.847 31.6667 18.6667C31.6667 11.4864 25.847 5.66669 18.6667 5.66669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdManagement);
export default __webpack_public_path__ + "static/media/adManagement.afd0e6c0c733adac81eb9278640a9f67.svg";
export { ForwardRef as ReactComponent };